import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  variant?: "row" | "grid";
}

export default function NewsCard({ item, variant = "row" }: NewsCardProps) {
  if (variant === "grid") {
    return (
      <Link
        to={`/news/detail/${item.id}`}
        className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
      >
        <div className="h-40 w-full overflow-hidden bg-secondary-200 md:h-44">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 黄色在线影视资讯`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-4">
          <span className="mb-2 inline-flex w-fit rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-700">
            {item.author}
          </span>
          <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-accent-600">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
            {item.summary}
          </p>
          <time className="mt-3 text-xs text-foreground-400">{item.publishDate}</time>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex gap-4 rounded-lg border border-transparent p-2 transition-colors hover:border-background-200 hover:bg-background-100"
    >
      <div className="h-20 w-28 flex-shrink-0 overflow-hidden rounded-md bg-secondary-200 md:h-24 md:w-36">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 黄色在线影视资讯`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <h3 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-accent-600 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 hidden text-sm leading-relaxed text-foreground-500 sm:block">
          {item.summary}
        </p>
        <div className="mt-auto flex items-center gap-3 pt-2 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1">
            <i className="ri-user-line" aria-hidden="true" />
            {item.author}
          </span>
          <time>{item.publishDate}</time>
        </div>
      </div>
    </Link>
  );
}